import * as Constants from "../constants/Constants";

export const checkUserRoles = (usersArray = []) => {
  try {
    if (Object.prototype.toString.call(usersArray) === "[object Array]") {
      //override users from parameter
      const users = usersArray && usersArray.length > 0 ? usersArray : [];
      const roles = JSON.parse(localStorage.getItem("roles"));
      return users.includes(roles?.roleName);
    } else
      throw new Error(
        "The parameter type must be an array of user role names with at least one user role name."
      );
  } catch (error) {
    console.error(error);
  }
};

export const modifyVDFValues = (vdfInfo) => {
  if (!vdfInfo) return null;
  const vdfKey = vdfInfo.split(" ").join("");
  const vdfValues = {
    CommerceHub: "chub",
    DirectEDI: "directEdi",
    DirectEDIRDS: "directEdiRDS",
  };
  return vdfValues[vdfKey] || vdfInfo;
};

export const renderLeftNavItem = (vdf, workflowSteps) => {
  const vdfValue = modifyVDFValues(vdf);
  return Array.isArray(workflowSteps) && workflowSteps.includes(vdfValue);
};

export const isEmailValid = (email) => {
  const regex = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9](?!.*-\.))*\.[a-zA-Z]([a-zA-Z0-9])+$/;
  return regex.test(email);
};

export const isMerchantEmailValid = (email) => {
  const regex = /^(?!\.)(?!.*\.$)(?!.*?\.\.)[a-zA-Z0-9'._-]+$/;
  return regex.test(email);
};

export const checkOnBoardingStatus = (statusValue = "", vendorStatus = []) => {
  const onboardingStatus = [
    Constants.VENDOR_SUBMISSION,
    Constants.MERCHANT_APPROVED,
    Constants.DOCUMENT_SUBMITTED,
  ];
  try {
    if (statusValue !== "") {
      const status =
        vendorStatus && vendorStatus.length > 0
          ? vendorStatus
          : onboardingStatus;
      return status.includes(statusValue);
    } else {
      return false;
    }
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const convertAccentedLettersToEnglish = (str) =>
  str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const checkMandatoryDocStatus = (onBoardingStatus, docStatuses = {}) => {
  if (
    onBoardingStatus === Constants.MERCHANT_APPROVED &&
    docStatuses?.isMandatoryDocumentPresent
  ) {
    return true;
  }

  if (
    onBoardingStatus === Constants.VENDOR_SUBMISSION &&
    docStatuses?.isMandatoryDocumentPresent &&
    docStatuses?.isDocumentModifiedAfterReturnToMerchant
  ) {
    return true;
  }

  return false;
};
export const filterVendorProfileId = (vendorData = {}) => {
  const { vendorDetail } = vendorData;
  if (
    vendorDetail &&
    !Array.isArray(vendorDetail) &&
    typeof vendorDetail === "object"
  ) {
    return vendorDetail.id;
  }
  return "";
};
